export default "__VITE_ASSET__DFKIbi_x__"